// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".elements__buy--icon i[_v-b24342da] {\n  padding: 5px;\n  cursor: pointer;\n  top: 5px;\n  right: -2px; }\n\n.elements__scrollable-container[_v-b24342da] {\n  max-height: calc(100vh - 100px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  width: calc(100% + 20px);\n  padding-right: 20px; }\n", ""]);
// Exports
module.exports = exports;
